import React from 'react'
import styled from 'styled-components'
import { Container, Col, Row } from 'react-bootstrap'
import Text from '~/components/UI/Text'
import { useTranslation } from '~/i18n'
import Box from '~/components/UI/Box'
import { COLORS } from '~/components/UI/Constants'
import breakpoints from '~/components/UI/breakpoints'
import Button from '~/components/Button'

const MyContainer = styled.div`
  padding: 0;
  padding-bottom: 40px;
`

const ContentContainer = styled.div<{ background?: string }>`
  position: relative;
  background-color: ${p => p.background || '#0084ff'};
  width: 100%;
  padding: 30px 5%;
  height: 650px;
  margin: auto;
  margin-bottom: 16px;
  ${breakpoints.md} {
    padding: 60px 5%;
    height: 670px;
  }
  ${breakpoints.lg} {
    padding: 60px 8%;
    width: 94%;
  }
  div > p {
    ${p => p.background ? '' : 'color: #fff'}
  }
  transition: height 320ms;
  > a {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
`

const HR = styled.div<{ backgroundImage?: boolean }>`
  display: block;
  ${p => p.backgroundImage ? 'background-image: linear-gradient(91deg, #0092ff, #0055ff);' : 'background: #fff'};
  width: 50%;
  margin: auto;
  height: 2px;
  margin-top: 32px;
  margin-bottom: 32px;
  
`

const ContentStep = styled.div<{ step: number, isRightTable?: boolean }>`
  padding: 0 24px;
  padding-bottom: 24px;
  :nth-child(3) {
    padding-bottom: 0;
  }
  position: relative;
  border-left: 1px dashed ${p => p.isRightTable ? COLORS.PRIMARY : '#fff'};
  >p:first-child {
    line-height: 1.4;
    top: -9px;
    position: relative;
  }
  ::before {
    content: "${p => p.step}";
    color: ${p => p.isRightTable ? '#fff' : COLORS.PRIMARY};
    position: absolute;
    height: 16px;
    width: 16px;
    ${p => p.isRightTable
    ? 'background-image: linear-gradient(135deg, #0092ff, #0055ff);'
    : 'background-color: #fff'};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0px;
    left: -8px;
  }
`

const Title = styled(Text)`
  font-size: 24px;
  ${breakpoints.md} {
    font-size: 32px;
  }
`

const Section3Investment = () => {
  const [t] = useTranslation()
  return (
    <MyContainer>
      <Container>
        <Title bold centered padding='0 0 56px 0'>
          {t`2 cách mua “Phần sở hữu”`}
        </Title>
        <Row>
          <Col md={6}>
            <ContentContainer>
              <Title bold color='#fff' centered>
                {t`Mua trực tiếp từ Infina`}
              </Title>
              <HR />
              <Box height='auto'>
                <ContentStep step={1}>
                  <Text size={24}>
                    {t`Chọn BĐS và số phần`}
                  </Text>
                  <Text>
                    {t`Chọn BĐS ưa thích đang mở đầu tư trên Infina và số phần muốn đầu tư`}
                  </Text>
                </ContentStep>
                <ContentStep step={2}>
                  <Text size={24}>
                    {t`Tiến hành đặt cọc`}
                  </Text>
                  <Text>
                    {t`Thanh toán cọc thông qua chuyển khoản ngân hàng hoặc thanh toán trực tiếp`}
                  </Text>
                </ContentStep>
                <ContentStep step={3}>
                  <Text size={24}>
                    {t`Ký hợp đồng chính thức`}
                  </Text>
                  <Text>
                    {t`Sau khi thanh toán cọc, hợp đồng chính thức sẽ được chuyển đến bạn`} 🎉
                    </Text>
                </ContentStep>
              </Box>
              <Button margin='auto' link href='/properties' border='0' style={{ background: '#fff' }}>
                <Text bold color={COLORS.PRIMARY}>
                  {t`Danh Sách BĐS >`}
                </Text>
              </Button>
            </ContentContainer>
          </Col>
          <Col md={6}>
            <ContentContainer background='#f9fafc'>
              <Title bold centered size={32}>
                {t`Mua lại từ sàn giao dịch`}
              </Title>
              <HR backgroundImage />
              <Box height='auto'>
                <ContentStep isRightTable step={1}>
                  <Text size={24}>
                    {t`Chọn BĐS và số phần`}
                  </Text>
                  <Text>
                    {t`Chọn gói đầu tư đang được bán với mức giá tốt trên sàn giao dịch và số phần muốn đầu tư`}
                  </Text>
                </ContentStep>
                <ContentStep isRightTable step={2}>
                  <Text size={24}>
                    {t`Tiến hành thanh toán`}
                  </Text>
                  <Text>
                    {t`Khách hàng thanh toán sớm nhất sẽ được ưu tiên mua`}
                  </Text>
                </ContentStep>
                <ContentStep isRightTable step={3}>
                  <Text size={24}>
                    {t`Ký hợp đồng chính thức`}
                  </Text>
                  <Text>
                    {t`Sau khi thanh toán, hợp đồng chính thức sẽ được chuyển đến bạn`} 🎉
                  </Text>
                </ContentStep>
              </Box>
              <Button primary margin='auto' link href='/trading' border='0'>
                <Text bold color='#fff'>
                  {t`Sàn Giao Dịch >`}
                </Text>
              </Button>
            </ContentContainer>
          </Col>
        </Row>
      </Container>
    </MyContainer>
  )
}

export default Section3Investment
